/**
 * API Platino — gold-api.com (https://gold-api.com/docs)
 * En este servicio el oro (XAU) y la plata (XAG) son gratuitos sin autenticación.
 * Platino (XPT): GET /price/XPT (USD) y GET /price/XPT/EUR (EUR).
 * Precio por onza troy.
 */
const GOLD_API_BASE_URL = "https://api.gold-api.com";
const PLATINUM_SYMBOL = "XPT";

/**
 * @returns {Promise<{ price: number, currency: string, symbol: string, updatedAt: string }>}
 */
export const fetchPlatinumPriceUSD = async () => {
  const response = await fetch(`${GOLD_API_BASE_URL}/price/${PLATINUM_SYMBOL}`);
  if (!response.ok) {
    throw new Error(`API Platino USD: HTTP ${response.status}`);
  }

  const data = await response.json();
  if (!data?.price) {
    throw new Error("API Platino USD: sin precio");
  }

  return {
    price: data.price,
    currency: data.currency || "USD",
    symbol: data.symbol || PLATINUM_SYMBOL,
    updatedAt: data.updatedAt,
  };
};

/**
 * @returns {Promise<{ price: number, currency: string, symbol: string, updatedAt: string }>}
 */
export const fetchPlatinumPriceEUR = async () => {
  const response = await fetch(
    `${GOLD_API_BASE_URL}/price/${PLATINUM_SYMBOL}/EUR`
  );
  if (!response.ok) {
    throw new Error(`API Platino EUR: HTTP ${response.status}`);
  }

  const data = await response.json();
  if (!data?.price) {
    throw new Error("API Platino EUR: sin precio");
  }

  return {
    price: data.price,
    currency: data.currency || "EUR",
    symbol: data.symbol || PLATINUM_SYMBOL,
    updatedAt: data.updatedAt,
  };
};
